import { render, staticRenderFns } from "./drop-code.vue?vue&type=template&id=345100c4"
import script from "./drop-code.vue?vue&type=script&lang=js"
export * from "./drop-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports